var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHaptikCampaigns(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5635 4.47148C16.2057 4.07816 15.6467 4.07816 15.3113 4.4977C14.9759 4.91724 14.9759 5.57277 15.3337 5.96608C15.9151 6.62161 16.2281 7.48691 16.2281 8.43087C16.2281 9.37484 15.9151 10.2401 15.3337 10.8957C14.9759 11.289 14.9759 11.9445 15.3113 12.364C15.4902 12.5738 15.7138 12.6787 15.9598 12.6787C16.1834 12.6787 16.407 12.5738 16.5635 12.3903C17.5026 11.3414 17.9946 9.92548 17.9946 8.43087C17.9946 6.93627 17.4803 5.52032 16.5635 4.47148Z",
    fill: "#FEFEFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9467 0.0647185C12.7678 -0.0401662 12.5442 -0.0139448 12.3653 0.117161L6.99881 4.86319H1.60995C0.715533 4.86319 0 5.70227 0 6.75112V10.1074C0 11.1563 0.715533 11.9954 1.60995 11.9954H2.2584L3.06338 17.4494C3.1081 17.764 3.3317 18 3.60003 18H5.74662C5.90315 18 6.05967 17.9213 6.17147 17.764C6.28327 17.6067 6.32799 17.4231 6.28327 17.2396L5.50066 11.9954H6.99881L12.3653 16.7414C12.4547 16.82 12.5889 16.8725 12.7007 16.8725C12.7902 16.8725 12.8796 16.8463 12.9467 16.7938C13.1256 16.6889 13.2597 16.4529 13.2597 16.217V0.641584C13.2374 0.405594 13.1256 0.195824 12.9467 0.0647185Z",
    fill: "#FEFEFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHaptikCampaigns);
export default __webpack_public_path__ + "static/media/haptik-campaigns.e5574b27.svg";
export { ForwardRef as ReactComponent };